<template>
    <Modal2
        id="awaiting-message-details"
        :class="{ xlarge: true }"
        :title="`Talep Detay / ${getTicketPlatform()}`"
        :show-footer="false"
        @cancel="closeModal"
    >
        <!-- Güncellenmiş information banner -->
        <div class="tabMenu">
            <button
                v-for="(tab, index) in tabs"
                :key="index"
                :class="{ active: activeTab === index }"
                @click="activeTab = index"
            >
                {{ tab.name }}
            </button>
        </div>
        <div v-if="activeTab === 0">
            <div class="information-banner" v-if="ticket.returnType">
                <i class="material-icons">info</i>
                <span v-if="ticket.returnType === 'email' || !ticket.returnType">
                {{ $t("ticket.thisPersonEmailAnswered") }}
            </span>
                <span v-else-if="ticket.returnType === 'whatsapp'">
                {{ $t("ticket.thisPersonWpAnswered") }}
                <a href="javascript:void(0)" @click="showWhatsappChatStarter"> {{ $t("ticket.clickStartWpChat") }}</a>
            </span>
            </div>
            <div class="ticket-status-wrapper">
                <div style="display: flex;">
                    <span class="status-title">{{ $t("ticket.requestProgress") }}</span>
                    <a-tooltip :title="$t('message.ticketOnlyMail')">
                        <i class="material-icons warning-icon">info</i>
                    </a-tooltip>
                </div>
                <TicketStatusSwitcher
                    :currentStatus="ticket.status"
                    :statusList="statusList"
                    @update-status="(status) => changeTicketStatus(ticket._id, status)"
                />
            </div>
            <div class="user-info-profile" @click="viewContactProfile">
                <div class="profile-header">
                    <ContactAvatar
                        :contact="ticket.visitor"
                        :key="$_.get(ticket.visitor, '_id', 'unknown')"
                        :badge="true"
                        badge-type="visitor-offline"
                        v-if="isVisitorExist()"
                    />
                    <div class="contact-profile-info">
                        <div class="contact-profile-fullname">{{ visitorInfo.fullname }}</div>
                        <div class="platform-info">
                            <div class="platform-name">
                                <div class="platform-icon-wrapper">
                                    <WhatsappIcon
                                        v-if="$_.get(ticket.visitor, 'platform') === 'whatsapp'"
                                        color="#25D366"
                                        class="option-icon"
                                    />
                                    <TelegramIcon v-if="$_.get(ticket.visitor, 'platform') === 'telegram'"
                                                  class="option-icon" />
                                    <MessengerIcon v-if="$_.get(ticket.visitor, 'platform') === 'messenger'"
                                                   class="option-icon" />
                                    <webIcon v-if="$_.get(ticket.visitor, 'platform') === 'web'" class="option-icon"
                                             color="black;" />
                                    <mailIcon v-if="$_.get(ticket.visitor, 'platform') === 'email'"
                                              class="option-icon" />
                                    <MetaIcon v-if="$_.get(ticket.visitor, 'platform') === 'meta-leads'"
                                              class="option-icon" />
                                    <InstagramIcon
                                        v-if="$_.get(ticket.visitor, 'platform') === 'instagram'"
                                        class="option-icon"
                                        special-background-mode
                                    />
                                    {{ getPlatformName() }}
                                </div>
                                <div class="value-item">
                                    <i class="material-icons">email</i>
                                    {{ getEmailAddress() || "-" }}
                                </div>

                                <div class="value-item" @click.stop="showStartChat">
                                    <i class="material-icons">phone</i>
                                    {{ getPhoneNumber() || "-" }}
                                </div>
                            </div>
                            <div
                                v-if="$_.get(ticket.visitor, 'platform') === 'whatsapp'"
                                class="whatsapp-number"
                                @click.stop="showWhatsappChatStarterModal = true"
                            >
                                <a href="javascript:void(0)">{{ $_.get(ticket.visitor, "whatsappNumber") }}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="selectedHistory.type === 'osr'">
                <div class="ticket-message">
                    <strong>{{ $t("ticket.requestMessage") }}</strong>
                    <p>{{ selectedHistory.messages }}</p>
                </div>
                <div v-if="!ticket.resolved">
                    <quill-editor v-model="responseText" :options="editorOption" />
                    <div class="email-sender-info">
                        <p class="email-info-text">{{ $t("ticket.emailTicketWillBeSentHint") }}</p>
                    </div>
                    <a-select v-model="selectedSenderMailId" style="width: 100%">
                        <a-select-option :key="senderMail.mail" v-for="senderMail of senderMails"
                                         :value="senderMail._id">
                            {{ senderMail.mail }}
                        </a-select-option>
                    </a-select>
                </div>
                <b-row class="mt-4" v-if="!ticket.resolved">
                    <b-col md="12">
                        <div v-if="ticket.type === 'offline'" style="position: absolute; right: 42%;">
                            <div class="action-button-tickets" @click="aiCopilot = { type: 'fix-grammar' }">
                                <div class="material-icons">auto_fix_high</div>
                            </div>
                        </div>
                        <div v-if="isSupsisMail()" class="mail-warning">
                            <div class="text">
                                {{ $t("ticket.withEmailWillNotRecievice") }}
                            </div>
                            <div @click="$router.replace('/integrations/mail')" class="link">
                                {{ $t("ticket.clickAddMailAddress") }}
                            </div>
                        </div>
                        <SupsisButton @click="closeModal" ghost class="float-right">
                            <template>
                                {{ $t("message.cancel") }}
                            </template>
                        </SupsisButton>
                        <SupsisButton
                            @click="sendResponseAndClose"
                            primary
                            :disabled="responseSending"
                            class="float-right mr-2"
                        >
                            <template v-if="!responseSending">{{ $t("ticket.sendReplyCloseTicket") }}</template>
                            <template v-else>
                                <font-awesome-icon icon="spinner" spin />
                                {{ $t("message.sending") }}...
                            </template>
                        </SupsisButton>

                        <SupsisButton
                            @click="closeTicket"
                            warning
                            :disabled="responseSending"
                            class="float-right mr-2"
                            ghost
                        >
                            {{ $t("ticket.closeTicket") }}
                        </SupsisButton>
                    </b-col>
                </b-row>
            </div>
            <div v-else-if="selectedHistory.type === 'automation'">
                <div class="ticket-message">
                    <strong>{{ $t("ticket.requestMessage") }}</strong>
                    <p>{{ selectedHistory.ticket.ticketMessage }}</p>
                </div>
                <div v-if="!ticket.resolved">
                    <quill-editor v-model="responseText" :options="editorOption" />
                    <div class="email-sender-info">
                        <p class="email-info-text">{{ $t("ticket.emailTicketWillBeSentHint") }}</p>
                    </div>
                    <a-select v-model="selectedSenderMailId" style="width: 100%">
                        <a-select-option :key="senderMail.mail" v-for="senderMail of senderMails"
                                         :value="senderMail._id">
                            {{ senderMail.mail }}
                        </a-select-option>
                    </a-select>
                </div>
                <b-row class="mt-4">
                    <b-col md="12">
                        <div v-if="isSupsisMail()" class="mail-warning">
                            <div class="text">
                                {{ $t("ticket.withEmailWillNotRecievice") }}
                            </div>
                            <div @click="$router.replace('/integrations/mail')" class="link">
                                {{ $t("ticket.clickAddMailAddress") }}
                            </div>
                        </div>

                        <SupsisButton @click="closeModal" ghost class="float-right">
                            <template>
                                {{ $t("message.cancel") }}
                            </template>
                        </SupsisButton>
                        <SupsisButton
                            @click="sendResponseAndClose"
                            primary
                            :disabled="responseSending"
                            class="float-right mr-2"
                        >
                            <template v-if="!responseSending"> {{ $t("ticket.sendReplyCloseTicket") }}</template>
                            <template v-else>
                                <font-awesome-icon icon="spinner" spin />
                                {{ $t("message.sending") }}...
                            </template>
                        </SupsisButton>
                        <SupsisButton
                            @click="closeTicket"
                            warning
                            :disabled="responseSending"
                            class="float-right mr-2"
                            ghost
                        >
                            {{ $t("ticket.closeTicket") }}
                        </SupsisButton>
                    </b-col>
                </b-row>
            </div>
            <div v-else>
                <div v-if="ticket.type !== 'form'" style="display: flex; flex-direction: column">
                    <div v-if="filteredMessages.length" v-chat-scroll class="waiting-ticket-messages">
                        <MessageList
                            :contextMenuVisable="false"
                            :always-scroll-to-bottom="false"
                            :colors="colors"
                            :messages="getMessages()"
                            :participants="getParticipants()"
                        />
                    </div>
                    <div v-if="!ticket.resolved">
                        <quill-editor v-model="responseText" :options="editorOption" />
                        <div class="email-sender-info" v-if="!['instagram-comment', 'instagram-mention', 'page-comment', 'trendyol'].includes(ticket.type)">
                            <p class="email-info-text">{{ $t("ticket.emailTicketWillBeSentHint") }}</p>
                        </div>
                        <a-select
                            v-model="selectedSenderMailId"
                            v-if="!['instagram-comment', 'instagram-mention', 'page-comment', 'trendyol'].includes(ticket.type)"
                        >
                            <a-select-option :key="senderMail.mail" v-for="senderMail of senderMails"
                                             :value="senderMail._id">
                                {{ senderMail.mail }}
                            </a-select-option>
                        </a-select>
                    </div>
                    <div v-if="!ticket.resolved">
                        <div class="actions">
                            <a-switch
                                v-if="['instagram-comment'].includes(ticket.type)"
                                name="hidden"
                                v-model="hidden"
                                checked-children="Hidden Comment"
                                un-checked-children="Unhidden Comment"
                            />
                        </div>
                        <div class="actions">
                            <div v-if="
                            ['instagram-comment', 'instagram-mention', 'page-comment', 'trendyol','chatbot'].includes(
                                ticket.type
                            ) || !!this.ticket.osrPayload
                        ">
                                <div class="action-button-tickets" @click="aiCopilot = { type: 'fix-grammar' }">
                                    <div class="material-icons">auto_fix_high</div>
                                </div>
                            </div>
                            <SupsisButton @click="closeModal" ghost>
                                {{ $t("message.cancel") }}
                            </SupsisButton>
                            <SupsisButton
                                @click="sendResponse(true)"
                                primary
                                :disabled="responseSending"
                                v-if="
                            !['instagram-comment', 'instagram-mention', 'page-comment', 'trendyol'].includes(
                                ticket.type
                            )
                        "
                            >
                        <span v-if="responseSending">
                            <font-awesome-icon icon="spinner" spin />
                            {{ $t("message.sending") }}...
                        </span>
                                <span v-else>{{ $t("message.send") }}</span>
                            </SupsisButton>
                            <SupsisButton
                                @click="() => deleteComment()"
                                danger
                                :disabled="responseSending"
                                v-if="['instagram-comment'].includes(ticket.type)"
                            >
                        <span v-if="responseSending">
                            <font-awesome-icon icon="spinner" spin />
                            Deleting...
                        </span>
                                <span v-else>{{ $t("ticket.deleteCommentAndClose") }}</span>
                            </SupsisButton>
                            <SupsisButton
                                @click="() => sendAsComment(false)"
                                primary
                                :disabled="responseSending"
                                v-if="['instagram-comment', 'instagram-mention', 'page-comment'].includes(ticket.type)"
                            >
                        <span v-if="responseSending">
                            <font-awesome-icon icon="spinner" spin />
                            {{ $t("message.sending") }}...
                        </span>
                                <span v-else>{{ $t("message.replyAsAComment") }}</span>
                            </SupsisButton>
                            <SupsisButton
                                @click="() => sendAsComment(true)"
                                primary
                                :disabled="responseSending"
                                v-if="['instagram-comment', 'page-comment'].includes(ticket.type)"
                            >
                        <span v-if="responseSending">
                            <font-awesome-icon icon="spinner" spin />
                            {{ $t("message.sending") }}...
                        </span>
                                <span v-else>{{ $t("message.ReplyAsAPm") }}</span>
                            </SupsisButton>
                            <SupsisButton
                                @click="replyTrendyolQuestion"
                                primary
                                :disabled="responseSending"
                                v-if="['trendyol'].includes(ticket.type)"
                            >
                        <span v-if="responseSending">
                            <font-awesome-icon icon="spinner" spin />
                            {{ $t("message.sending") }}...
                        </span>
                                <span v-else>{{ $t("ticket.sendReplyAndClose") }}</span>
                            </SupsisButton>
                        </div>
                    </div>
                </div>
                <div v-else-if="ticket.type === 'form'">
                    <div class="form-content">
                        <TicketInboxContents :submissionId="ticket.formSubmission" />
                    </div>
                    <div v-if="!ticket.resolved">
                        <quill-editor v-model="responseText" :options="editorOption" />
                        <div class="email-sender-info">
                            <p class="email-info-text">{{ $t("ticket.emailTicketWillBeSentHint") }}</p>
                        </div>
                        <a-select v-model="selectedSenderMailId" style="width: 100%">
                            <a-select-option :key="senderMail.mail" v-for="senderMail of senderMails"
                                             :value="senderMail._id">
                                {{ senderMail.mail }}
                            </a-select-option>
                        </a-select>
                        <b-row class="mt-4">
                            <b-col md="12">
                                <div v-if="isSupsisMail()" class="mail-warning">
                                    <div class="text">
                                        {{ $t("ticket.withEmailWillNotRecievice") }}
                                    </div>
                                    <div @click="$router.replace('/integrations/mail')" class="link">
                                        {{ $t("ticket.clickAddMailAddress") }}
                                    </div>
                                </div>

                                <SupsisButton @click="closeModal" ghost class="float-right">
                                    <template>
                                        {{ $t("message.cancel") }}
                                    </template>
                                </SupsisButton>
                                <SupsisButton
                                    @click="replyToFormTicket"
                                    primary
                                    :disabled="responseSending"
                                    class="float-right mr-2"
                                >
                                    <template v-if="!responseSending"> Cevap Gönder ve Kapatma
                                    </template>
                                    <template v-else>
                                        <font-awesome-icon icon="spinner" spin />
                                        {{ $t("message.sending") }}...
                                    </template>
                                </SupsisButton>
                                <SupsisButton
                                    @click="sendResponseAndClose"
                                    primary
                                    :disabled="responseSending"
                                    class="float-right mr-2"
                                >
                                    <template v-if="!responseSending"> {{ $t("ticket.sendReplyCloseTicket") }}
                                    </template>
                                    <template v-else>
                                        <font-awesome-icon icon="spinner" spin />
                                        {{ $t("message.sending") }}...
                                    </template>
                                </SupsisButton>
                                <SupsisButton
                                    @click="closeTicket"
                                    warning
                                    :disabled="responseSending"
                                    class="float-right mr-2"
                                    ghost
                                >
                                    {{ $t("ticket.closeTicket") }}
                                </SupsisButton>
                            </b-col>
                        </b-row>
                    </div>
                </div>
                <div v-else>
                    <b-alert show variant="info">{{ $t("message.chatNotFound") }}</b-alert>
                </div>
            </div>
            <Modal2
                v-if="showWhatsappChatStarterModal"
                @cancel="showWhatsappChatStarterModal = false"
                :title="$t('ticket.startChatWp')"
                :showFooter="false"
            >
                <WhatsappChatStarter
                    :default-phone-number="getPhoneNumber()"
                    channel-override
                    phone-number-override
                    @close="showWhatsappChatStarterModal = false"
                    :default-email="$_.get(ticket.visitor, 'email')"
                    :default-name="$_.get(ticket.visitor, 'fullname')"
                />
            </Modal2>
            <AICopilot
                v-if="aiCopilot"
                @close="aiCopilot = null"
                :type="'ticket'"
                :ticketText="responseText"
                :osrPayload="ticket.osrPayload"
                :ticketMessage="ticket.conversation ? ticket.conversation._id : null"
                @change="responseText = $event"
            />
            <div class="navigation-buttons">
                <SupsisButton @click="navigate(-1)" ghost>
                    <span class="keyboard-shortcut">Ctrl+←</span>
                    Önceki
                </SupsisButton>
                <SupsisButton @click="navigate(1)" ghost>
                    <span class="keyboard-shortcut">Ctrl+→</span>
                    Sonraki
                </SupsisButton>
            </div>
        </div>
        <div v-if="activeTab === 1" class="responses-container">
            <template v-if="!ticket.responses || ticket.responses.length === 0">
                <div class="no-responses">
                    <i class="material-icons">warning</i>
                    Herhangi bir cevap bulunamadı
                </div>
            </template>
            <template v-else>
                <div v-for="response in ticket.responses" :key="response._id" class="ticket-response">
                    <div class="response-header">
                        <div class="user">
                            <AgentAvatar
                                :userID="response.user._id"
                                :size="30"
                                singleChar
                            />
                            <span class="user-name">{{ response.user.name }}</span>
                        </div>
                        <div class="response-date">
                            <template v-if="response.text.includes('Archived by')">
                                Ticket Bu Tarihte Arşivlendi: {{ formatDate(response.answerDate) }}
                            </template>
                            <template v-else>
                                Ticket Şu Tarihte Cevap Verdi: {{ formatDate(response.answerDate) }}
                            </template>
                        </div>
                    </div>
                    <div class="response-content">
                        {{ response.text }}
                    </div>
                </div>
            </template>
        </div>

    </Modal2>
</template>
<script>
import Modal2 from "../../../../components/common/Modal2.vue";
import MessageList from "../../../../components/popup-chat/MessageList.vue";
import * as _ from "lodash";
import moment from "moment/moment";
import { toNewMessagesModel } from "../../../../utils/chat";
import { maskContactInfo, isMaskContactInfo } from "../../../../utils/utils";
import SupsisButton from "../../Settings/components/SupsisButton.vue";
import ticket from "../../../../store/modules/ticket";
import { mapActions, mapGetters, mapState } from "vuex";
import VisitorDetail from "../../Visitors/VisitorDetail.vue";
import ContactAvatar from "../../../../components/popup-chat/chat-window/ContactAvatar.vue";
import MessengerIcon from "../../Chatbot/pages/integrations/svg/MessengerIcon.vue";
import TelegramIcon from "../../Chatbot/pages/integrations/svg/TelegramIcon.vue";
import MetaIcon from "../../Chatbot/pages/integrations/svg/MetaIcon.vue";
import WhatsappIcon from "../../Chatbot/pages/integrations/svg/WhatsappIcon.vue";
import InstagramIcon from "../../Chatbot/pages/integrations/svg/InstagramIcon.vue";
import webIcon from "../../Visitors/components/svg/WebIcon.vue";
import WhatsappChatStarter from "../../Integrations/meta-leads/WhatsappChatStarter.vue";
import TicketStatusSwitcher from "./TicketStatusSwitcher.vue";
import TicketInboxContents from "../../Forms/Components/FormInbox/TicketInboxContents.vue";
import AgentAvatar from "../../../../components/common/AgentAvatar.vue";
import AICopilot from "../../../../components/popup-chat/chat-window/ChatMessageArea/components/AICopilot.vue";

export default {
    name: "AwaitingTicketDetails",
    components: {
        TicketStatusSwitcher,
        WhatsappChatStarter,
        VisitorDetail,
        SupsisButton,
        ContactAvatar,
        MessageList,
        Modal2,
        MessengerIcon,
        TelegramIcon,
        MetaIcon,
        WhatsappIcon,
        InstagramIcon,
        webIcon,
        TicketInboxContents,
        AgentAvatar,
        AICopilot,
    },
    props: ["ticket", "statusList", "changeTicketStatus"],
    data: () => ({
        aiCopilot: null,
        activeTab: 0,
        tabs: [
            { name: "Ticket İçeriği" },
            { name: "Cevaplar" },
        ],
        showWhatsappChatStarterModal: false,
        responseText: null,
        selectedHistory: {
            visitor: {},
            messages: [],
            ticket: {},
            type: null,
        },
        hidden: false,
        responseSending: false,
        colors: {
            header: {
                bg: "#4e8cff",
                text: "#ffffff",
            },
            launcher: {
                bg: "#4e8cff",
            },
            messageList: {
                bg: "#ffffff",
            },
            sentMessage: {
                bg: "#4e8cff",
                text: "#ffffff",
            },
            receivedMessage: {
                bg: "#eaeaea",
                text: "#222222",
            },
            userInput: {
                bg: "#f4f7f9",
                text: "#565867",
            },
        },
        editorOption: {
            theme: "snow",
            modules: {
                toolbar: [
                    ["bold", "italic", "underline", "strike"],
                    [{ header: [1, 2, 3, 4, 5, 6, false] }],
                    [{ color: [] }, { background: [] }],
                    [{ align: [] }],
                    [{ indent: "-1" }, { indent: "+1" }],
                    ["link"],
                ],
            },
        },
        senderMails: [],
        selectedSenderMailId: null,
    }),
    computed: {
        ...mapGetters({
            getUser: "user/getUser",
        }),
        ...mapState({
            allMailAddresses: (state) => state.mail.allMailAddresses,
        }),
        visitorInfo() {
            if (!this.isVisitorExist())
                return {
                    email: "-",
                    fullname: "-",
                };
            if (this.selectedHistory.type === "osr") return this.selectedHistory.ticket.osrPayload;
            if (!!this.selectedHistory.visitor.email && !!this.selectedHistory.visitor.fullname)
                return this.selectedHistory.visitor;
            if (
                !!this.selectedHistory.ticket.conversation &&
                !!this.selectedHistory.ticket.conversation.email &&
                !!this.selectedHistory.ticket.conversation.fullname
            )
                return this.selectedHistory.ticket.conversation;
            return {
                email: "-",
                fullname: "-",
            };
        },
        filteredMessages() {
            return this.selectedHistory.messages.filter((m) => "undefined" === typeof m.type);
        },
    },
    methods: {
        ...mapActions({
            loadOldMessages: "chat/loadOldMessages",
            addNewWindow: "app/addNewWindow",
            updateFormStatus: "forms/updateFormStatus",
        }),
        formatDate(date) {
            return moment(date).format("DD MMM YYYY HH:mm");
        },
        showStartChat(e) {
            if (e) e.stopPropagation();
            if (this.getPhoneNumber()) {
                this.showWhatsappChatStarterModal = true;
            }
        },
        getEmailAddress() {
            const val = (
                this.$_.get(this.ticket.osrPayload, "email") || this.ticket.visitorEmailAddress || this.ticket.visitor?.email
            );
            return isMaskContactInfo('email') ? maskContactInfo(val) : val;
        },
        getPhoneNumber() {
            console.log("this.ticket.visitorPhoneNumber...", this.ticket.visitorPhoneNumber);

            const val = (
                this.$_.get(this.ticket.osrPayload, "phone") ||
                this.ticket.visitorPhoneNumber ||
                this.ticket.visitor?.phoneNumber ||
                this.ticket.visitor?.whatsappNumber
            );
            return isMaskContactInfo('phone') ? maskContactInfo(val) : val;
        },
        getTicketPlatform() {
            // instagram-comment, instagram-mention, page-comment
            if (this.ticket.type === "instagram-comment") {
                return "Instagram Yorumu";
            } else if (this.ticket.type === "instagram-mention") {
                return "Instagram Bahsetmeleri";
            } else if (this.ticket.type === "page-comment") {
                return "Facebook Sayfa Yorumu";
            } else if (this.ticket.type === "trendyol") {
                return "Trendyol";
            } else if (this.ticket.type === "chatbot") {
                return "Chatbot Üzerinden";
            } else if (!!this.ticket.osrPayload) {
                return "Web Formdan Gelen Talep";
            } else if (this.ticket.type === "form") {
                return "Supsis Formdan Gelen Talep";
            } else if (this.ticket.type === "automation") {
                return "Otomasyon ile Gelen Talep";
            } else {
                return "Chatbot Üzerinden Gelen Talep";
            }
        },

        isFormSubmission() {
            return this.ticket.type === "form" || !!this.ticket.formSubmission;
        },
        getPlatformName() {
            const platformMap = {
                whatsapp: "WhatsApp",
                telegram: "Telegram",
                messenger: "Messenger",
                web: "Web",
                email: "Email",
                "meta-leads": "Meta",
                instagram: "Instagram",
                "instagram-v2": "Instagram V2",
                trendyol: "Trendyol",
                form: "Form",
            };
            if (this.isFormSubmission()) {
                return platformMap.form;
            }
            if (!this.ticket.visitor || !this.ticket.visitor.platform) {
                return "Bilinmiyor";
            }
            return platformMap[this.ticket.visitor.platform] || this.ticket.visitor.platform;
        },

        viewContactProfile() {
            if (this.isFormSubmission()) {
                return;
            }
            if (!this.isVisitorExist() || !this.ticket.visitor || !this.ticket.visitor._id) {
                return;
            }
            this.addNewWindow({
                type: "show-visitor",
                title: this.ticket.visitor.fullname || "Ziyaretçi",
                payload: {
                    visitorId: this.ticket.visitor._id,
                },
                footer: false,
                zIndexStart: 1001,
            });
        },
        getTicketTitle() {
            // Ticket Detail of ....
            return `Ticket Details`;
        },
        isSupsisMail() {
            const isExistSupsisMail = (this.senderMails || []).find((x) => x.type === "supsis");
            return this.selectedSenderMailId === isExistSupsisMail?._id;
        },
        closeModal() {
            this.$emit("close");
        },
        sendTicketForm() {
            this.$emit("confirm", {
                selectedHistory: this.selectedHistory,
                responseText: this.responseText,
                senderMailId: this.selectedSenderMailId,
                resolved: false,
            });
            this.markAsRead();
        },
        sendResponse(shouldResolve = false) {
            if (shouldResolve && typeof shouldResolve === 'object' && shouldResolve.isTrusted) {
                shouldResolve = true;
            }
            console.log("AwaitingTicketDetails sendResponse çağrıldı, shouldResolve:", shouldResolve);

            const isMetaPlatform = ["instagram-comment", "instagram-mention", "page-comment"].includes(
                this.ticket.type
            );
            const isFormPlatform = this.ticket.type === "form";

            if (this.selectedSenderMailId === "" && !isMetaPlatform) {
                this.$message.error("Please select email sender");
                return;
            }

            const emitData = {
                selectedHistory: this.selectedHistory,
                responseText: this.responseText,
                senderMailId: this.selectedSenderMailId,
                resolved: shouldResolve,
            };

            console.log("Emit edilecek data:", emitData);
            this.$emit("confirm", emitData);
            if (isFormPlatform) {
                this.markAsRead();
            }
            this.responseText = "";
        },
        async markAsRead() {
            const siteId = this.ticket.siteId;
            const submissionId = this.ticket.formSubmission;
            await this.updateFormStatus({
                siteId: siteId,
                submissionId: submissionId,
                newStatus: "ticket",
            });
        },
        sendResponseAndClose() {
            this.$confirm({
                title: "Cevap Gönder ve Ticket'ı Kapat",
                content: "Cevabı göndermek ve ticket'ı kapatmak istediğinizden emin misiniz?",
                okText: "Evet",
                cancelText: "Hayır",
                onOk: () => {
                    this.$emit("close-ticket", this.ticket._id);
                    this.sendResponse(true); // true = ticket'ı kapat
                    // this.closeTicket();
                },
            });
        },
        replyToFormTicket() {
            this.$confirm({
                title: "Cevap Gönder ve Ticket Açık Kalsın",
                content: "Cevabı göndermek ve ticket'ı açık bırakmak istediğinizden emin misiniz?",
                okText: "Evet",
                cancelText: "Hayır",
                onOk: () => {
                    //this.$emit("close-ticket", this.ticket._id);
                    this.sendResponse(false); // false = ticket açık kalsın
                },
            });
        },
        //ard arda iki kere modal uyarısı sorduğu için istek üzerine kapatıldı
        // closeTicket() {
        //     this.$confirm({
        //         title: "Ticket'ı Kapat",
        //         content: "Bu ticket'ı kapatmak istediğinizden emin misiniz? Muhammet ALi Karakaya",
        //         okText: "Evet",
        //         cancelText: "Hayır",
        //         onOk: () => {
        //             this.$emit("close-ticket", this.ticket._id);
        //             this.closeModal();
        //         },
        //     });
        // },
        getMessages() {
            let allMessages = toNewMessagesModel(this.filteredMessages, this);
            if (this.typingMessage) {
                allMessages = [
                    ...allMessages,
                    {
                        type: "typing",
                        data: {
                            text: this.typingMessage,
                        },
                    },
                ];
            }

            return allMessages;
        },
        init() {
            const ticketMessages = JSON.parse(localStorage.getItem("savedTicketMessages") || "{}");
            this.responseText = ticketMessages[this.ticket._id] || "";
            this.selectedHistory.ticket = this.ticket;
            this.selectedHistory.visitor = this.ticket.visitor || {};
            if (!!this.ticket.osrPayload) {
                this.selectedHistory.messages = this.ticket.osrPayload.message;
                this.selectedHistory.type = "osr";
            } else {
                if (this.ticket.conversation && this.ticket.conversation._id) {
                    this.loadOldMessages(this.ticket.conversation._id).then((response) => {
                        let items = response.data.data;
                        items = _.orderBy(
                            _.uniqBy(items, (q) => q.uniqMessageId || q._id),
                            (q) => moment(q.createdDate).toDate().getTime(),
                            "asc",
                        );
                        this.selectedHistory.messages = items;
                    });
                } else {
                    this.selectedHistory.messages = [];
                }
                this.selectedHistory.type = this.ticket.type;
            }
        },
        getParticipants() {
            const supportUsers = this.filteredMessages
                .filter((x) => x.messageType === "user" || x.messageType === "private")
                .map((x) => ({
                    id: x.userId,
                    name: x.username,
                }));

            return _.uniqBy(supportUsers, (q) => q.name);
        },
        isVisitorExist() {
            const visitor = _.get(this.selectedHistory, "visitor", {}) || {};
            const visitorKeys = Object.keys(visitor);
            return visitorKeys.length || [].length;
        },
        replyTrendyolQuestion() {
            this.$emit("replyTrendyolQuestion", {
                selectedHistory: this.selectedHistory,
                responseText: this.responseText,
            });
            this.responseText = "";
        },
        sendAsComment(isPrivate = false) {
            this.$emit("sendAsComment", {
                selectedHistory: this.selectedHistory,
                responseText: this.responseText,
                isPrivate,
            });
            this.responseText = "";
        },
        deleteComment() {
            this.$emit("deleteComment", {
                selectedHistory: this.selectedHistory,
                responseText: this.responseText,
            });
            this.responseText = "";
        },
        changeHideStatusIGComment(hide) {
            this.$emit("changeHideStatusIGComment", {
                selectedHistory: this.selectedHistory,
                hide,
            });
        },
        saveLocaleStore: _.debounce(function () {
            const ticketMessages = JSON.parse(localStorage.getItem("savedTicketMessages") || "{}");
            localStorage.setItem(
                "savedTicketMessages",
                JSON.stringify({
                    ...ticketMessages,
                    [this.ticket._id]: this.responseText,
                })
            );
        }, 200),
        navigate(direction) {
            this.$emit("navigate", direction);
        },
        showWhatsappChatStarter() {
            this.showWhatsappChatStarterModal = true;
        },
    },
    watch: {
        responseText() {
            console.log("responseText...", this.responseText);
            this.saveLocaleStore();
        },
        hidden: {
            handler: function (isHidden) {
                if (this.ticket.type === "instagram-comment") {
                    this.changeHideStatusIGComment(isHidden);
                }
            },
            immediate: true,
        },
        ticket: {
            handler() {
                this.init();
            },
            immediate: true,
        },
    },
    mounted() {
        console.log("this.allMailAddresses...", this.allMailAddresses);
        this.senderMails = this.allMailAddresses.filter(
            (x) => (!!x.isSender && (!!x.isSenderVerified || !!x.isVerified)) || x.type === "supsis"
        );

        // Default olarak her zaman ilk mail adresini seç
        if (this.senderMails && this.senderMails.length > 0) {
            this.selectedSenderMailId = this.senderMails[0]._id;
        }

        this.init();
    },
    beforeDestroy() {
        localStorage.removeItem("savedTicketMessages");
    },
};
</script>

<style lang="scss">
.tabMenu {
    display: flex;
    border-bottom: 1px solid #e8e8e8;
    margin-bottom: 16px;
}

.tabMenu button {
    padding: 12px 16px;
    cursor: pointer;
    background-color: transparent;
    border: none;
    border-bottom: 2px solid transparent;
    transition: color 0.3s, border-bottom 0.3s;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
}

.tabMenu button:hover {
    color: #40a9ff;
}

.tabMenu button.active {
    color: #1890ff;
    border-bottom: 2px solid #1890ff;
}
.mail-warning {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 10px;
    background-color: #f0f0f0;
    border-radius: 5px;
    margin-bottom: 10px;

    .text {
        font-size: 14px;
        font-weight: 600;
        color: #ff0000;
    }

    .link {
        font-size: 14px;
        font-weight: 600;
        color: #4e8cff;
        cursor: pointer;
    }
}

.email-sender-info {
    margin-bottom: 8px;

    .email-info-text {
        font-size: 13px;
        color: #666;
        margin: 0;
        font-weight: 500;
        background-color: #f8f9fa;
        padding: 8px 12px;
        border-radius: 4px;
        border-left: 3px solid #1890ff;
    }
}

#awaiting-message-details {
    .ant-select {
        width: 100%;
    }
    .information-banner {
        background-color: #e6f7ff;
        border: 1px solid #91d5ff;
        color: #1890ff;
        padding: 10px;
        margin-bottom: 10px;
        border-radius: 4px;
        font-weight: bold;
        display: flex;
        align-items: center;

        i {
            margin-right: 10px;
        }

        a {
            color: #1890ff;
            text-decoration: underline;
            margin-left: 5px;
            cursor: pointer;

            &:hover {
                color: #40a9ff;
            }
        }
    }

    .ticket-status-wrapper {
        padding: 5px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: white;
    }

    .ticket-message {
        background: white;
        padding: 20px !important;
        border-left: 5px solid pink;
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .actions {
        display: flex;
        justify-content: flex-end;
        gap: 10px;
        margin-top: 10px;
    }

    .user-info-profile {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 10px;
        border: 1px solid #f1f4f7;
        border-radius: 8px;
        background-color: #fff;
        cursor: pointer;

        .profile-header {
            display: flex;
            align-items: center;
            gap: 10px;
            width: 100%;

            &:hover {
                .contact-profile-fullname {
                    text-decoration: underline;
                }
            }

            .contact-profile-info {
                display: flex;
                flex-direction: column;
                gap: 5px;
                align-items: flex-start;

                .contact-profile-fullname {
                    font-weight: bold;
                    font-size: 16px;
                }

                .platform-info {
                    display: flex;
                    flex-direction: column;
                    gap: 2px;
                    font-size: 12px;
                    color: #8c8c8c;
                    font-weight: 500;

                    .platform-name {
                        display: flex;
                        gap: 10px;
                        align-items: center;

                        &:hover {
                            cursor: pointer;
                            text-decoration: underline;
                        }

                        .value-item {
                            display: flex;
                            gap: 5px;
                            align-items: center;

                            .material-icons {
                                font-size: 16px;
                            }
                        }
                    }

                    .platform-icon-wrapper {
                        display: flex;
                        gap: 5px;
                        align-items: center;

                        .option-icon {
                            width: 16px;
                            height: 16px;
                        }
                    }

                    .whatsapp-number {
                        cursor: pointer;
                        color: #007bff;
                        text-decoration: underline;
                    }
                }
            }
        }
    }

    .navigation-buttons {
        display: flex;
        justify-content: space-between;
        margin-top: 10px;

        .keyboard-shortcut {
            margin-right: 3px;
            font-size: 0.8rem;
            font-weight: bold;
            color: #000;
            background-color: #f1f1f1;
            padding: 2px 5px;
            border-radius: 5px;
            border: 1px solid #ccc;
            width: max-content;
            height: 19px;
            display: flex;
            justify-content: center;
            align-items: center;
            overflow: hidden;
        }
    }

    .form-content {
        max-height: 500px;
        overflow: scroll;
    }

    .responses-container {
        max-height: 400px;
        overflow-y: auto;
        padding-right: 10px;
    }

    .no-responses {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        color: #ff0000;
        font-weight: bold;
        padding: 20px;
        background-color: #fff3cd;
        border: 1px solid #ffeeba;
        border-radius: 8px;

        i {
            margin-right: 10px;
        }
    }

    .ticket-response {
        background-color: #fff;
        border: 1px solid #e0e0e0;
        border-radius: 8px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        margin-bottom: 16px;
        padding: 16px;
        transition: box-shadow 0.3s;

        &:hover {
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
        }

        .response-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 12px;

            .user {
                display: flex;
                align-items: center;

                .user-name {
                    margin-left: 8px;
                    font-weight: bold;
                    color: #333;
                }
            }

            .response-date {
                font-size: 12px;
                color: #999;
                font-weight: bold;
                font-family: Arial, sans-serif;
            }
        }

        .response-content {
            font-size: 14px;
            color: #555;
        }
    }
}
.status-title {
    white-space: nowrap;
}

.warning-icon {
    margin-top: 2px;
    margin-left: 10px;
    color: #ff6b6b;
    font-size: 20px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        transform: scale(1.1);
    }
}

.action-button-tickets {
    background: var(--color-bg-neutral-default);
    border: 1px solid var(--border-neutral-default);
    border-radius: 40px;
    line-height: 0;
    cursor: pointer;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;

    &.voice-speech {
        animation-name: voiceSpeakAnimation;
        animation-duration: 1s;
        animation-iteration-count: infinite;
    }

    &.primary {
        background: var(--primary-default-button-color) !important;
        border: 1px solid var(--primary-default-button-color) !important;

        .material-icons {
            color: white !important;
        }

        svg > g > path {
            fill: white !important;
        }
    }

    .material-icons {
        font-size: 18px;
    }

    &.send {
        .material-icons {
            font-size: 18px;
        }
    }

    .material-icons {
        color: var(--primary-default-button-color);
    }

    svg > g > path {
        fill: var(--primary-default-button-color) !important;
    }
}
</style>
